import {withRouter} from "react-router";
import * as React from 'react'
import {AppState, AppUser, ChildProps, Maybe, PlanActions, PlanDoc, PlanType} from "../types";
import {useDispatch, useSelector} from "react-redux";
import {fetchAppUser, firebaseLogout,} from '../actions/user';
import styled from 'styled-components';
import FileMetadata from "../components/dashboard/FileMetadata";
import Title from "antd/lib/typography/Title";
import {FabContainer, palette} from '../constants/styles';
import {MdAdd} from 'react-icons/md';
import {getStartPayloadOf} from "../utils/redux";
import BasicPlanModal from "../components/dashboard/modals/BasicPlanModal";
import PlanComponent from "../components/dashboard/PlanComponent";
import ErrorDetailsModal from "../components/dashboard/modals/ErrorDetailsModal";
import {has_access_to_alpha, has_access_to_beta, has_access_to_deprecated, has_access_to_study} from "../utils/user";
import {Button} from "antd";


const DashboardRoot = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
padding: 10px 0;
width: 100vw;
//overflow-x: none;
`;

const StyledDashboard = styled.div`
  width: 90%;
  background-color: ${palette.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  padding: 5px 10px;
`;

const Dashboard: React.FunctionComponent<ChildProps> = ({history}) => {
  const dispatch = useDispatch();
  const openBasicPlanModal = (plan_type: PlanType) => dispatch({type: PlanActions.SET_BASIC_PLAN_MODAL, payload: {modal_open: true, plan_type: plan_type}});
  const logOut = () => dispatch(firebaseLogout());
  const setOptionsOpen = (open: boolean) => dispatch({type: PlanActions.SET_PLAN_OPTIONS, payload: open});
  const planOptionsOpen = useSelector<AppState, boolean>(state => state.plans.planOptionsOpen);
  const plans = useSelector<AppState, PlanDoc[]>(state => state.plans.plans);
  const user = useSelector<AppState, Maybe<AppUser>>(state => state.user.user);
  React.useEffect(() => {
    const fetchPlans = () => dispatch(getStartPayloadOf(PlanActions.FETCH_PLANS));
    const fetchUser = () => dispatch(fetchAppUser());
    fetchPlans();
    fetchUser();
  }, [dispatch]);

  return (
    <>
      <DashboardRoot>
        <Title
          level={2}
        >
          Generador de planes de pensión
        </Title>
        <Title level={4} style={{position: "absolute", top: "5px", left: "5px", margin: "0px", padding: "0px"}}>
          Créditos restantes: {user?.available_pdfs}
        </Title>
        <Button style={{position: "absolute", top: "5px", right: "5px"}} type="primary" danger onClick={()=> { logOut() }}>
          Cerrar sesión
        </Button>
        <StyledDashboard>
          <FileMetadata user={user} />
          {
            plans.map((plan, idx) => (
              <PlanComponent
                  user={user}
                key={idx}
                border={idx !== plans.length - 1}
                {...plan}
              />
            ))
          }
        </StyledDashboard>
        {has_access_to_deprecated(user) && (
            <>
              {
                planOptionsOpen && (
                    <FabContainer
                        onClick={() => openBasicPlanModal(PlanType.ORIGINAL)}
                        top={76}
                        backgroundColor={palette.terciaryColor}
                    >
                      Básico
                    </FabContainer>
                )
              }
              {
                planOptionsOpen && (
                    <FabContainer
                        onClick={() => openBasicPlanModal(PlanType.ORGINAL_RETROACTIVE)}
                        top={67}
                        backgroundColor={palette.finautaOldOrange}
                    >
                      Retroact
                    </FabContainer>
                )
              }
            </>
        )}
        { has_access_to_beta(user) &&
          (
            <>
              { planOptionsOpen && (
                  <FabContainer
                      onClick={() => openBasicPlanModal(PlanType.BASIC)}
                      top={58}
                      backgroundColor={palette.secondaryColor}
                  >
                    🚀 Básico
                  </FabContainer>
              )}
            </>
          )
        }
        { has_access_to_alpha(user) &&
        (
            <>
              { planOptionsOpen && (
                  <FabContainer
                      onClick={() => openBasicPlanModal(PlanType.RETROACTIVE)}
                      top={49}
                      backgroundColor={palette.marron}
                  >
                    🚀 Retroact
                  </FabContainer>
              )}
            </>
        )
        }
        { has_access_to_study(user) &&
        (
            <>
              { planOptionsOpen && (
                  <FabContainer
                      onClick={() => openBasicPlanModal(PlanType.STUDY)}
                      top={40}
                      backgroundColor={palette.finautaOrange}
                  >
                    🚀 Estudio
                  </FabContainer>
              )}
              { planOptionsOpen && (
                  <FabContainer
                      onClick={() => openBasicPlanModal(PlanType.DIAGNOSTIC)}
                      top={32}
                      backgroundColor={palette.morado}
                  >
                    🚀<br/>Diag.
                  </FabContainer>
              )}
            </>

        )
        }
        <FabContainer
          onClick={() => setOptionsOpen(!planOptionsOpen)}
        >
          <MdAdd color="#ffffff" size="40px" />
        </FabContainer>
        <BasicPlanModal/>
        <ErrorDetailsModal
        />
      </DashboardRoot>
    </>
  );

}

export default withRouter(Dashboard);